module.exports = __webpack_public_path__ + "img/05.137adf27.png";